import React, { useEffect, useState } from 'react';
import classes from './OpeningHours.module.css';
import DeleteButton from '../../../../components/UI/Buttons/DeleteButton';
import OpeningHoursModal from '../../Modals/OpeningHours/OpeningHoursModal';
import { weekdayFromNumberToString } from '../../../../utils/calendarUtils';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';

import EditButton from '../../../../components/UI/Buttons/EditButton';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
  setOpeningHoursModal: (value: number) => void;
};

const OpeningHours: React.FC<Props> = ({ isModalOpen, onModalClose, setOpeningHoursModal }) => {
  const [selectedItem, setSelectedItem] = useState('');
  const [indexOfList, setIndexOfList] = useState<number>();
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  const OpeningHoursSlots = calendarAndSlots.calendar_items;

  const handleDelete = async (item: any) => {
    const found = OpeningHoursSlots.find((e: any) => e == item);
    const filteredData = [...OpeningHoursSlots].filter((item) => item !== found);
    let dataToPost = [
      {
        ...calendarData[0],
        calendar_items: filteredData,
      },
    ];
    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
  };
  const onEditClick = (item: any, index: number) => {
    setSelectedItem(item);
    setOpeningHoursModal(1);
    setIndexOfList(index);
  };
  useEffect(() => {
    if (!isModalOpen) {
      setSelectedItem('');
    }
  }, [isModalOpen]);
  return (
    <div>
      <div className={classes.container}>
        <div className={classes.mainContainer}>
          <text className={classes.headerText}>{translations('day')}</text>
          <text className={classes.headerText}>{translations('from')}</text>
          <text className={classes.headerText}>{translations('to')}</text>
        </div>
        <div>
          {OpeningHoursSlots.map((item: any, index: any) => {
            return (
              <div key={index} className={classes.flatlistContainer}>
                <div className={classes.textContainer}>
                  <text className={classes.text}>
                    {translations(weekdayFromNumberToString(item?.weekday_id))}
                  </text>
                </div>
                <div className={classes.textContainer}>
                  <text className={classes.text}>{item.start_time}</text>
                </div>
                <div className={classes.textContainer}>
                  <text className={classes.text}>{item.end_time}</text>
                </div>
                <div className={classes.textContainer}>
                  <text className={classes.text}>
                    {item.timeslot_capacity ? item.timeslot_capacity : '-'}
                  </text>
                </div>
                <div className={classes.button}>
                  <EditButton onClick={() => onEditClick(item, index)} />
                </div>
                <div className={classes.button}>
                  <DeleteButton onClick={() => handleDelete(item)} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <OpeningHoursModal
        isOpen={isModalOpen}
        index={indexOfList}
        item={selectedItem}
        onClose={onModalClose}
      />
    </div>
  );
};

export default OpeningHours;
